import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid2';
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import github from '../../../../src/assets/providers/github.svg';
import gitlab from '../../../../src/assets/providers/gitlab.svg';
import google from '../../../../src/assets/providers/google.svg';
import linkedin from '../../../../src/assets/providers/linkedin.svg';
import Svg from '../../elements/svg/Svg';
import Text from '../../elements/text/Text';
import Title from '../../elements/title/Title';

const StyledCard = styled(Card)({
  width: 150,
});

const StyledBox = styled('div')(({ theme, connected }) => ({
  opacity: connected ? 1.0 : 0.5,
  '&:hover': {
    opacity: 1.0,
  },
  marginBottom: theme.spacing(2),
  display: 'flex',
  justifyContent: 'center',
}));

const StyledCardAction = styled(CardActions)(({ theme, connected }) => ({
  color: 'white',
  backgroundColor: connected
    ? theme.palette.error.main
    : theme.palette.action.disabled,
  justifyContent: 'center',
  '&:hover': {
    backgroundColor: connected
      ? theme.palette.error.dark
      : theme.palette.action.active,
    cursor: 'pointer',
  },
}));

const StyledGrid = styled(Grid)(({ theme }) => ({
  justifyContent: 'flex-start',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
  },
  marginTop: theme.spacing(1),
}));

const imageMap = {
  google: google,
  gitlab: gitlab,
  github: github,
  linkedin: linkedin,
};

const SocialCards = ({ providerData, handleConnect, handleDisconnect }) => {
  const { t } = useTranslation();

  return (
    <>
      <Title subTitle text={t('socialProviders', { ns: 'sectionTitles' })} />
      <StyledGrid container spacing={2}>
        {providerData.map((provider) => {
          const isConnected = provider.connected;
          return (
            <Grid key={provider.id}>
              <StyledCard>
                <CardContent>
                  <StyledBox connected={isConnected} mb={2}>
                    <Svg src={imageMap[provider.id]} width="50%" />
                  </StyledBox>
                  <Text subtitle align="center">
                    {_.capitalize(provider.name)}
                  </Text>
                </CardContent>
                {isConnected ? (
                  <Link
                    onClick={() => handleDisconnect(provider.id)}
                    color="inherit"
                    underline="none"
                  >
                    <StyledCardAction
                      data-testid="disconnect-action"
                      connected={isConnected}
                    >
                      <Text bodyBold>
                        {t('deactivateSocialLogin', { ns: 'buttons' })}
                      </Text>
                    </StyledCardAction>
                  </Link>
                ) : (
                  <Link
                    onClick={() => handleConnect(provider.id, provider.url)}
                    color="inherit"
                    underline="none"
                  >
                    <StyledCardAction data-testid="connect-action">
                      <Text bodyBold>
                        {t('activateSocialLogin', { ns: 'buttons' })}
                      </Text>
                    </StyledCardAction>
                  </Link>
                )}
              </StyledCard>
            </Grid>
          );
        })}
      </StyledGrid>
    </>
  );
};

export default SocialCards;

SocialCards.propTypes = {
  providerData: PropTypes.object.isRequired,
  handleConnect: PropTypes.func.isRequired,
  handleDisconnect: PropTypes.func.isRequired,
};
